export * from "ce/reducers/uiReducers/mainCanvasReducer";
import type { ReduxAction } from "actions/ReduxActionTypes";
import type { UpdateCanvasPayload } from "actions/pageActions";
import {
  handlers as CE_handlers,
  initialState,
  type MainCanvasReduxState,
} from "ce/reducers/uiReducers/mainCanvasReducer";
import { MAIN_CONTAINER_WIDGET_ID } from "constants/WidgetConstants";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import { createImmerReducer } from "utils/ReducerUtils";

const handlers = {
  ...CE_handlers,

  [ReduxActionTypes.INIT_MODULE_CANVAS_LAYOUT]: (
    state: MainCanvasReduxState,
    action: ReduxAction<UpdateCanvasPayload>,
  ) => {
    if (state.initialized) return;

    const mainCanvas =
      action.payload.widgets &&
      action.payload.widgets[MAIN_CONTAINER_WIDGET_ID];

    state.width = mainCanvas?.rightColumn || state.width;
    state.height = mainCanvas?.minHeight || state.height;
  },

  [ReduxActionTypes.RESET_EDITOR_REQUEST]: (state: MainCanvasReduxState) => {
    state.initialized = false;
  },
};

const mainCanvasReducer = createImmerReducer(initialState, handlers);

export default mainCanvasReducer;
